import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomNavbar from "../../components/CustomNavbar";
//import SidebarDashboard from '../../components/SidebarDashboard';
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";
import {
  getDivision,
  saveDivision,
  editDivision,
  deleteDivision,
} from "../../redux/division/actions";
import messages from "../../redux/messages";
import SidebarConfig from "../../components/SidebarConfig";
import { Formik } from "formik";
import * as Yup from "yup";

const Division = (props) => {
  const schema = Yup.object().shape({
    codigo: Yup.string()
      .ensure()
      .required("**Campo requerido")
      .test("codigo-format", "**Solo admite números y letras", (value) => {
        // Lógica de temporizador para la validación
        if (value === "") {
          return true; // Campo vacío, no validamos todavía
        }

        if (value.length < 1) {
          return true; // No validamos hasta que se escriban al menos 1 caracter
        }

        // Aquí puedes definir tu patrón personalizado
        const pattern = /^[A-Za-z0-9]+$/;
        return pattern.test(value);
      }),
    descripcion: Yup.string()
      .ensure()
      .required("**Campo requerido")
      .test("codigo-format", "**Solo admite letras", (value) => {
        // Lógica de temporizador para la validación
        if (value === "") {
          return true; // Campo vacío, no validamos todavía
        }

        if (value.length < 1) {
          return true; // No validamos hasta que se escriban al menos 1 caracter
        }

        // Aquí puedes definir tu patrón personalizado
        const pattern =
          /^[a-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]+$/;
        return pattern.test(value);
      }),
  });
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  //const [loadingType, setLoadingType] = useState('initial');
  // const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const {
    division,
    divisionLength,
    loading,
    saveLoader,
    divisionError,
    formError,
  } = useSelector((store) => store.division);
  const pages = Math.ceil(divisionLength / limit);

  const columns = [
    {
      Header: "Codigo",
      accessor: "codigo",
    },
    {
      Header: "Descripción",
      accessor: "descripcion",
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const getADivision = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getDivision(
        {
          offset: offs,
          limit: lim,
          filter: filt,
        },
        parseInt(props.match.params.type)
      )
    );

  useEffect(() => getADivision(), [props.match.params.type]);

  const addArea = () => {
    setShowModal(true);
    setEdit(false);
    //setLoadingType('modal');
    // setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    //setLoadingType('modal');
    // setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    if (!e.target.filter.value.trim()) {
      return;
    }
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getADivision(oOffset, limit, e.target.filter.value);
    // if(!filter.trim()){
    //   return;
    // }
    //setLoadingType('initial');
    // dispatch(getDivision({
    //   offset: offset,
    //   limit: limit,
    //   filter: filter
    // }));
  };

  const onSubmit = (req) => {
    if (!edit) {
      dispatch(
        saveDivision(req, parseInt(props.match.params.type), setShowModal)
      );
    } else {
      dispatch(
        editDivision(
          req,
          editItem.id,
          index,
          parseInt(props.match.params.type),
          setShowModal
        )
      );
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getADivision(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteDivision(id, index, parseInt(props.match.params.type)));
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">División</h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                {/* <Col xs="auto">
                  <Form.Control
                  onChange={ e => setFilter(e.target.value)}
                  placeholder="Buscar"
                  className="rounded-pill form-control-sm"
                  type="search"></Form.Control>
                </Col> */}
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => addArea()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            divisionLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={division} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={divisionLength}
                  pages={pages}
                  pagFunc={getADivision}
                />
              </>
            )
          )}
          {!loading && divisionLength === 0 && divisionError === "" && (
            <Alert variant="info" className="my-4">
              Aún no hay división actual, comienza agregando algunos
            </Alert>
          )}
          {!loading && !!divisionError && (
            <Alert variant="danger" className="my-4">
              {divisionError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            codigo: edit ? editItem.codigo : null,
            descripcion: edit ? editItem.descripcion : null,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form
              onSubmit={handleSubmit}
              // noValidate
              // validated={validated}
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  {edit ? "Editar División" : "Crear división"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="my-1">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Código
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      name="codigo"
                      className="rounded-pill"
                      type="text"
                      value={values.codigo}
                      onBlur={handleBlur("codigo")}
                      onChange={handleChange}
                      isInvalid={touched.codigo && !!errors.codigo}
                      isValid={touched.codigo && !errors.codigo}
                      placeholder="Código"
                    ></Form.Control>
                    {touched.codigo && errors.codigo && (
                      <div>
                        <small className="text-danger px-2">
                          {errors.codigo}
                        </small>
                      </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite números y letras
                    </Form.Control.Feedback> */}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                  <Form.Label column sm="12" md="4">
                    Descripción
                  </Form.Label>
                  <Col sm="12" md="8">
                    <Form.Control
                      name="descripcion"
                      className="rounded-pill"
                      type="text"
                      value={values.descripcion}
                      onBlur={handleBlur("descripcion")}
                      onChange={handleChange}
                      isInvalid={touched.descripcion && !!errors.descripcion}
                      isValid={touched.descripcion && !errors.descripcion}
                      placeholder="Descripción"
                    ></Form.Control>
                    {touched.descripcion && errors.descripcion && (
                      <div>
                        <small className="text-danger px-2">
                          {errors.descripcion}
                        </small>
                      </div>
                    )}
                    {/* <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite letras
                    </Form.Control.Feedback> */}
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoader}
                  variant="primary"
                  type="submit"
                >
                  {saveLoader && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default Division;
